import {Card, CardContent, CardHeader, CardTitle} from '@/components/ui/card'
import { Slider } from '@/components/ui/slider'
import {Badge} from "@/components/Badge.tsx";
import {Users2Icon, CarIcon} from "lucide-react";
import { useCalculator, KPI_PARKOVANI_NASTUPU } from '@/contexts/CalculatorContext'
import { motion, AnimatePresence } from "framer-motion"

export function NastupySliderCard() {
  const {
    nastupy,
    setNastupy,
    getNastupyPercentage
  } = useCalculator()

  const hasParkingSpot = nastupy >= KPI_PARKOVANI_NASTUPU

  return (
      <Card className="w-full">
        <CardHeader>
          <div className="flex items-center gap-2">
            <Users2Icon className="w-5 h-5" />
            <div>
              <CardTitle>2. složka</CardTitle>
              <p className="text-sm text-muted-foreground mt-1">
                Absolutní počet nástupů za půlrok
              </p>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <div className="text-center">
            <div className="text-3xl font-bold text-primary">
              {nastupy} {nastupy === 1 ? 'nástup' : 'nástupů'}
            </div>
            <div className="text-sm text-muted-foreground mt-1">
              ({getNastupyPercentage(nastupy)}%)
            </div>
          </div>
          <Slider
              value={[nastupy]}
              onValueChange={(values) => setNastupy(values[0])}
              min={0}
              max={20}
              step={1}
              className="w-full p-2"
          />
          <div className="flex justify-between text-sm text-muted-foreground">
            <span>0 nástupů</span>
            <span>14+ nástupů</span>
          </div>
          <div className="flex justify-between mt-4">
            <Badge label="následuj. 6 měsíců" variant="yellow"/>
            <Badge label="Každých 6 měsíců" variant="blue"/>
          </div>
          <AnimatePresence>
            {hasParkingSpot && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
                className="mt-4 p-3 bg-green-50 border border-green-200 rounded-md flex items-center justify-center gap-2"
              >
                <motion.div
                  animate={{
                    x: [0, 10, 0],
                    rotate: [0, 5, -5, 0]
                  }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                >
                  <CarIcon className="w-6 h-6 text-green-600" />
                </motion.div>
                <span className="text-sm text-green-700 font-medium pl-3">
                  Parkovací místo na dalších 6 měsíců
                </span>
              </motion.div>
            )}
          </AnimatePresence>
        </CardContent>
      </Card>
  )
} 